import classes from "./LanguageSwitcher.module.scss";
import BaseLink from "../../ui/BaseLink";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "i18next";
import { Languages } from "../../../utils/models/languages";
import clsx from "clsx";

const languages: Languages[] = ["ru", "en"];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(i18n.language as Languages);

  const handleLanguageChange = (lng: Languages) => () => {
    if (lng === language) return;
    setLanguage(lng);
    changeLanguage(lng);
  };

  return (
    <div className={classes.switch}>
      {languages.map((lng) => (
        <BaseLink
          className={clsx({ [classes.inactive]: language !== lng })}
          onClick={handleLanguageChange(lng)}
          key={lng}
        >
          {lng}
        </BaseLink>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
